import React from 'react';
import { formatStatValue } from '../../utils/playerTrends';
import TrendArrow from './TrendArrow';

/**
 * StatCell Component
 *
 * Displays a single stat value with trend arrow and season average
 * @param {Object} props
 * @param {number|undefined} props.gameStat - Game stat value
 * @param {number|null} props.seasonAvg - Season average value
 * @param {'up'|'down'|'neutral'} props.trend - Trend direction
 * @param {string} props.label - Stat label (optional)
 * @param {string} props.teamColor - Team color for highlighting hot stats
 */
const StatCell = ({ gameStat, seasonAvg, trend, label, teamColor }) => {
  const getTrendColorClass = (trendDirection) => {
    switch (trendDirection) {
      case 'up':
        return 'bg-green-900/20';
      case 'down':
        return 'bg-red-900/20';
      default:
        return 'bg-gray-800/50';
    }
  };

  return (
    <td className={`px-3 py-4 text-center ${getTrendColorClass(trend)}`}>
      <div className="flex flex-col items-center justify-center gap-1">
        <div className="flex items-center gap-1">
          <span
            className="font-bold text-lg"
            style={{
              color: trend === 'up' && teamColor ? teamColor : 'white',
              textShadow: trend === 'up' && teamColor ? `0 0 10px ${teamColor}40` : 'none'
            }}
          >
            {gameStat ?? '-'}
          </span>
          {seasonAvg !== null && <TrendArrow trend={trend} />}
        </div>
        {seasonAvg !== null && (
          <span className="text-xs text-gray-400">
            Avg: {formatStatValue(seasonAvg)}
          </span>
        )}
      </div>
    </td>
  );
};

export default StatCell;
